import {
  isErstvertragOhneVorversicherung,
  isSecondCarReactive,
} from '@/features/Sparten/shared/renderConditions/kfz/sharedRenderConditions';
import { getSimpleChoiceMeta } from '@/utils/getSimpleChoiceMeta/getSimpleChoiceMeta';
import {
  SIMPLE_CHOICE,
  SIMPLE_CHOICE_META,
} from '@/features/ChoicesLists/Simple/types';
import { useInputStore } from '@/features/Sparten';
import { useGlobalStore } from '@/features/Global/store';
import { isPkwSparte } from '@/features/Sparten/shared/kfz/isPkwSparte';

export const kfzPreviousInsurance = () => {
  if (isErstvertragOhneVorversicherung.value || isSecondCarReactive.value) {
    return false;
  }

  if (
    !isPkwSparte(useGlobalStore().sparte) &&
    !getSimpleChoiceMeta(
      SIMPLE_CHOICE.WKZ,
      SIMPLE_CHOICE_META.KFZ_SF_KLASSE,
    ).includes(useInputStore().allgemein.wkz)
  ) {
    return true;
  }

  return !getSimpleChoiceMeta(
    SIMPLE_CHOICE.SF_KLASSE_KH,
    SIMPLE_CHOICE_META.SF_KLASSE_KH_NOT_RELEVANT_FOR_VORVERSICHERUNG,
  ).includes(useInputStore().sfKlasseKH);
};
